module.exports = __webpack_public_path__ + "static/arrastre_maanguera_cuatro_ruedas-d5a1d3b1c60d3e90b50d1b1754f45164.jpg";